import {
    USER_INFO,
    // TOKEN
} from "../action-types/auth";

const initialState = {
  user_info: null,
  // user_info: {first_name: '',
  //           is_verified: 0,
  //           is_email_verified: 0},
  // token: ''
}

const ReducerAuth = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_INFO:
      if(payload){
        return {
          ...state,
          user_info: payload ? JSON.stringify(payload) : null
        };
      }else{
        return initialState; 
      }
    // case TOKEN:
    //   return {
    //     ...state,
    //     token: payload
    //   };
    case 'RESET_STATE':
      // return {...state,
      //   user_info: null
      // }
      return initialState;
    default:
      return state;
  }
};

export default ReducerAuth;